import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faCircleQuestion } from '@fortawesome/pro-light-svg-icons'
import { faCircleQuestion as faCircleQuestionSolid } from '@fortawesome/pro-solid-svg-icons'
import { TooltipModule } from 'primeng/tooltip'

@Component({
    selector: 'fm-help-link',
    imports: [FaIconComponent, RouterModule, CommonModule, TooltipModule],
    templateUrl: './help-link.component.html',
    styleUrl: './help-link.component.scss',
})
export class HelpLinkComponent {
    public faCircleQuestion = faCircleQuestion
    public faCircleQuestionSolid = faCircleQuestionSolid
    public isHovered = false
}
